<template>
    <tr class="hover:bg-gray-100">
        <slot />
    </tr>
</template>
